import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskEmailRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-email',
	path: '/jira/servicedesk/projects/:projectKey/settings/email',
	exact: true,
};
